"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NullFormValidatationRender {
    /**
     * @inheritDoc
     */
    displayForField(inputName, error) {
        return Promise.resolve(null);
    }
    /**
     * @inheritDoc
     */
    display(errors) {
        return Promise.resolve(null);
    }
    /**
     * @inheritDoc
     */
    removeForField(inputName) {
        return Promise.resolve(null);
    }
    /**
     * @inheritDoc
     */
    removeForAll() {
        return Promise.resolve(null);
    }
}
exports.default = NullFormValidatationRender;
